// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2bKHS","label":"CategoryService_label__2PYdI","location":"CategoryService_location__2v1KF"};